import React from 'react'
import { cm } from '~/utils/utils'

interface ActiveDevelopersCardProps {
  count: number
  className?: string
}

export const ActiveDevelopersCard: React.FC<ActiveDevelopersCardProps> = ({ count, className }) => {
  return (
    <div
      className={cm(
        'bg-[rgba(255,255,255,0.5)] border border-white rounded-[24px] px-[32px] py-[24px]',
        !className?.includes('w-') && 'w-[782px]',
        !className?.includes('h-') && 'h-auto',
        className
      )}
    >
      <p className="font-['Geist',sans-serif] text-[12px] font-medium leading-[16px] text-[#2E1F36]">
        Active Developers
      </p>
      <p className="font-['Geist',sans-serif] text-[20px] font-bold leading-[22px] text-[#65558F] mt-[4px]">
        {count}
      </p>
    </div>
  )
}

export default ActiveDevelopersCard
